import { Component, Input, OnInit } from '@angular/core';
import { InventoryService } from 'src/app/services/inventory.service';
import { SalesChannelDialog } from '../../dialogs/sales-channel-dialog/sales-channel.dialog';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';

@Component({
  selector: 'app-item-sell',
  templateUrl: './item-sell.component.html',
  styleUrls: ['./item-sell.component.scss']
})
export class ItemSellComponent implements OnInit {

  @Input()
  public item: InventoryItem;

  @Input()
  public data: any;

  constructor(private inventoryService: InventoryService) {}

  ngOnInit(): void {

    if (this.item.sell == undefined) {
      this.item.sell = {
        price: 0,
        reason: ""
      }
    }
  }

  save() {
    this.inventoryService.updateOne(this.item).subscribe();
  }




}
